module.exports = __webpack_public_path__ + "img/full3-min.47e52ae1.png";